import * as API from 'services/api';
import type { ApiResponse, ApiError } from 'services/api';
import type { UserProfile } from '../types/user';

// =============================================================================
// GET /v1/me/
// =============================================================================
export namespace GetMe {
  export type ResponseData = UserProfile;

  export type Response = ApiResponse<ResponseData>;
  export type Error = ApiError;
}

export const getMe = async (): Promise<GetMe.Response> => {
  const res = await API.get('/v1/me/');
  return { data: res.data, status: res.status };
};

// =============================================================================
// PATCH /v1/me/
// =============================================================================
export namespace PatchMe {
  export interface RequestBody {
    first_name: string;
    last_name: string;
    preferred_2fa_method: 'email' | 'sms';
  }

  export type ResponseData = UserProfile;

  export type Response = ApiResponse<ResponseData>;
  export type Error = ApiError;
}

export const patchMe = async (
  data: PatchMe.RequestBody,
): Promise<PatchMe.Response> => {
  const res = await API.patch('/v1/me/', data);
  return { data: res.data, status: res.status };
};

// =============================================================================
// POST /v1/send_phone_verification/
// =============================================================================
export namespace PostSendPhoneVerification {
  export interface RequestBody {
    phone_number: string;
  }

  export interface ResponseData {
    message: string;
  }

  export type Response = ApiResponse<ResponseData>;
  export type Error = ApiError;
}

export const postSendPhoneVerification = async (
  data: PostSendPhoneVerification.RequestBody,
): Promise<PostSendPhoneVerification.Response> => {
  const res = await API.post('/v1/send_phone_verification/', data);
  return { data: res.data, status: res.status };
};

// =============================================================================
// POST /v1/verify_phone/
// =============================================================================
export namespace PostVerifyPhone {
  export interface RequestBody {
    phone_number: string;
    code: string;
  }

  export interface ResponseData {
    message: string;
  }

  export type Response = ApiResponse<ResponseData>;
  export type Error = ApiError;
}

export const postVerifyPhone = async (
  data: PostVerifyPhone.RequestBody,
): Promise<PostVerifyPhone.Response> => {
  const res = await API.post('/v1/verify_phone/', data);
  return { data: res.data, status: res.status };
};

// =============================================================================
// Legacy export for backwards compatibility
// =============================================================================
export const getUserProfile = async (authData?: any): Promise<{data?: UserProfile; error?: string; status: number}> => {
  try {
    const res = await API.get('/v1/me/', authData);
    return { data: res.data, status: res.status };
  } catch (error: any) {
    return { error: error.response?.data?.message || error.message || 'Failed to fetch user profile', status: error.response?.status || 500 };
  }
};
